var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpDownCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 364,
    viewBox: "0 0 132 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132 358V358C109.613 358 89.9414 343.154 83.8017 321.626L46.2311 189.89C40.3419 169.24 21.4728 155 2.48803e-06 155V155",
    stroke: "url(#paint0_linear_2853_27529)",
    strokeOpacity: 0.64,
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132 6V6C109.197 6 88.7349 20.0021 80.4763 41.2566L49.4207 121.182C41.4992 141.569 21.8719 155 1.27912e-06 155V155",
    stroke: "url(#paint1_linear_2853_27529)",
    strokeOpacity: 0.64,
    strokeWidth: 12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2853_27529",
    x1: 132,
    y1: 358,
    x2: -55.0375,
    y2: 259.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2853_27529",
    x1: 132,
    y1: 3.48311,
    x2: -28.9516,
    y2: 112.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownCurve);
export default __webpack_public_path__ + "97131/static/media/up-down-curve.a7ed4ed0d7131c84e50ff01eaeed453b.svg";
export { ForwardRef as ReactComponent };